<template lang="pug">
.icon-cancel
  svg(xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100")
    circle(cx="50" cy="50" :r="50")
    path(d="M33 33 L67 67z")
    path(d="M33 67 L67 33z")

  
</template>
<script>
import gsap from 'gsap'
export default {
  name: 'IconCancel',
  props: {},
  data() {
    return {
      t1: 0,
      t2: 0,
      t3: 0,
      d1: 0,
      d2: 0,
    }
  },
  computed: {},
  methods: {
    // animeIn() {
    //   gsap
    //     .timeline()
    //     .to(this, { t1: 1, duration: 0.2, ease: 'power3.out' })
    //     .to(this, { t2: 1, duration: 0.2, ease: 'power3.out' }, 0.1)
    //     .to(this, { t3: 1, duration: 0.2, ease: 'power3.out' }, 0.2)
    // },
    // animeOut() {
    //   gsap.to(this, { t1: 0, t2: 0, t3: 0, duration: 0.2, ease: 'power3.out' })
    // },
    // animation() {
    //   this.d1 += 0.8
    //   this.d2 += 8
    // },
  },
  mounted() {
    //gsap.ticker.add(this.animation)
  },
  destroy() {
    //gsap.ticker.remove(this.animation)
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.icon-cancel
  filter: grayscale(1)
  line-height: 0
  width: 100%
  height: 100%
  svg
    width: 100%
    height: 100%
    circle
      fill: $cl-red
    path
      stroke-linejoin: round
      stroke-linecap: round
      stroke: $cl-white
      stroke-width: 8
</style>
